const NoticeBanner = require('./classes/notice-banner');
const Breadcrumbs = require('./classes/breadcrumbs');

class App {
    constructor() {
        new NoticeBanner();
        new Breadcrumbs();
    }
}

new App();



// WEBPACK FOOTER //
// ./resources/js/app.js